import React from 'react';
import PropTypes from 'prop-types';
import DocumentTitle from 'react-document-title';
import { Redirect, withRouter } from 'react-router';
import _ from 'lodash';
import { useQuery, gql } from '@nerdwallet/apollo';

import DepartmentPage from '../components/company/department-page';
import NotFound from '../components/company/not-found';
import { logGqlError } from '~/client/lib/logger-utils';

const careerDataQuery = gql`
  query GreehhouseDepartment($kebabName: String!) {
    greenhouseDepartment(kebabName: $kebabName) {
      name
      id
      jobs {
        id
        title
        location
      }
    }
  }
`;

const DepartmentRoute = ({ match }) => {
  const slug = match?.params?.slug ?? '';
  const { data, loading, error } = useQuery(careerDataQuery, {
    variables: {
      kebabName: slug,
    },
  });

  if (loading) return null;

  if ((slug !== '' && slug.split(' ').length > 1) || /[A-Z]/.test(slug)) {
    const newSlug = _.kebabCase(slug);
    return <Redirect to={`/careers/${newSlug}`} />;
  }

  if (error || !data?.greenhouseDepartment?.name) {
    if (error) {
      logGqlError(error);
    }
    return <NotFound errorType="department" />;
  }

  return (
    <React.Fragment>
      <DocumentTitle title={`${data.greenhouseDepartment.name} | NerdWallet`} />
      <DepartmentPage department={data.greenhouseDepartment} />
    </React.Fragment>
  );
};

DepartmentRoute.displayName = 'Department Route';
DepartmentRoute.analyticsName = 'department_page';
DepartmentRoute.segmentPageName = 'careers_department';

DepartmentRoute.propTypes = {
  match: PropTypes.object,
};

export default withRouter(DepartmentRoute);
